export type Employee = {
  settings: {
    country: string;
  };
  company_detail?: {
    features?: {
      marketplace: boolean;
      marketplace_international: boolean;
    };
  };
};

export const isStoreEnabled = (employee: Employee) => {
  const is_us_based = employee.settings.country === 'us';

  const is_forma_store_enabled = employee.company_detail?.features?.marketplace;
  const is_international_store_enabled =
    employee.company_detail?.features?.marketplace_international;

  return (
    (is_forma_store_enabled && is_us_based) ||
    (is_international_store_enabled && !is_us_based)
  );
};
